module.exports = __webpack_public_path__ + "static/media/expand-light-icon.19774db1.svg";